import { Component, Input, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AiAgentResponse } from '../../../models/responses/ai-agent-response';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialog } from '@angular/material/dialog';
import { AddEditTransferDialogComponent } from '../add-edit-transfer-dialog/add-edit-transfer-dialog.component';
import { TransferRecipientResponse } from '../../../models/responses/transfer-recipient-response';
import { NgFor, NgIf } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { AiConfigurationPageEventsService } from '../../../events/ai-configuration-page-events.service';
import { TransferRecipientService } from '../../../services/transfer-recipient.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-transfer',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    NgFor,
    NgIf,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './transfer.component.html',
  styleUrl: './transfer.component.scss'
})
export class TransferComponent {
  @Input() aiAgent!: AiAgentResponse;
  filteredRecipients: TransferRecipientResponse[] = [];
  isLoadingArray: boolean[] = [];

  constructor(
    private dialog: MatDialog,
    private aiAgentPageEventService: AiConfigurationPageEventsService,
    private transferRecipientService: TransferRecipientService,
    private snackBar: MatSnackBar
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['aiAgent'].currentValue) {
      this.filteredRecipients = this.aiAgent.transferRecipients;
      this.isLoadingArray = Array.from({ length: this.filteredRecipients.length }, () => false);
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filteredRecipients = this.aiAgent.transferRecipients.filter(agent => agent.name.toLowerCase().includes(filterValue.toLowerCase()))
  }

  onAddTransfer() {
    this.dialog.open(AddEditTransferDialogComponent, {
      width: '50%',
      autoFocus: false,
      data: { aiAgent: this.aiAgent }
    });
  }

  onEditTransfer(tranferRecipient: TransferRecipientResponse) {
    this.dialog.open(AddEditTransferDialogComponent, {
      width: '50%',
      autoFocus: false,
      data: { aiAgent: this.aiAgent, tranferRecipient }
    });
  }

  onDeleteTransfer(transferRecipient: TransferRecipientResponse, index: number) {
    this.isLoadingArray[index] = true;

    this.transferRecipientService.batchDelete([transferRecipient.id!]).subscribe({
      next: () => {
        this.filteredRecipients = this.aiAgent.transferRecipients.filter(recipient => recipient.id != transferRecipient.id);
        this.aiAgentPageEventService.onRefreshAiAgentEvent.emit();
        this.isLoadingArray[index] = false;
        this.snackBar.open('Transfer removed successfully', 'Close', { duration: 5000 });
      },
      error: () => {
        alert('Error contact support');
        this.isLoadingArray[index] = false;
      }
    })
  }

}
